import { getTagsApiRequest } from '@/services/api/tags-api';
import { useStore } from '@/store';

export const populateTagsStoreCacheApiRequest = async (params: { type: string }) => {
  const store = useStore();
  const payload = await getTagsApiRequest(params);
  store.cache.populateTagsCache({
    type: params.type,
    data: payload,
  });
  return payload;
};
